module.exports = __webpack_public_path__ + "img/couples-066.aeb84104.jpg";